import { render, staticRenderFns } from "./treeQuestionEditor.vue?vue&type=template&id=0c9b71d2&scoped=true"
import script from "./treeQuestionEditor.vue?vue&type=script&lang=js"
export * from "./treeQuestionEditor.vue?vue&type=script&lang=js"
import style0 from "./treeQuestionEditor.vue?vue&type=style&index=0&id=0c9b71d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9b71d2",
  null
  
)

export default component.exports